/**
 * The automations list: standalone schedules and triggers plus workflows, in one shape so the list can sort,
 * filter and draw them alike. Schedules and triggers that belong to a workflow step are part of that
 * workflow, not automations of their own, so they are left out. A schedule that is on carries the next run the
 * server worked out. Newest change first.
 */
const buildAutomationListItems = ({ schedules = [], triggers = [], workflows = [] }) => {
  const scheduleRows = schedules
    .filter((schedule) => !schedule.workflowStepId)
    .map((schedule) => ({
      kind: 'schedules',
      id: schedule.id,
      name: schedule.title,
      when: schedule.cadenceSummary,
      nextRun: schedule.active ? schedule.nextRunSummary || null : null,
      what: schedule.promptSummary,
      active: schedule.active,
      threadId: schedule.threadId,
      updatedAt: schedule.updatedAt
    }));
  const triggerRows = triggers
    .filter((trigger) => !trigger.workflowStepId)
    .map((trigger) => ({
      kind: 'triggers',
      id: trigger.id,
      name: trigger.title,
      when: trigger.triggerSummary,
      what: trigger.promptSummary || null,
      active: trigger.active,
      threadId: trigger.threadId,
      updatedAt: trigger.updatedAt
    }));
  const workflowRows = workflows.map((workflow) => ({
    kind: 'workflows',
    id: workflow.isPlanning ? workflow.threadId : workflow.workflowId,
    name: workflow.name || workflow.title || 'Untitled workflow',
    when: workflow.isPlanning ? 'Pieve is still planning it' : 'Runs its steps in order',
    what: workflow.description || null,
    active: workflow.active === true,
    threadId: workflow.threadId,
    isPlanning: workflow.isPlanning === true,
    updatedAt: workflow.updatedOn || workflow.updatedAt
  }));

  return [...scheduleRows, ...triggerRows, ...workflowRows].sort((left, right) => String(right.updatedAt || '').localeCompare(String(left.updatedAt || '')));
};

export default buildAutomationListItems;
